export enum FollowUpStudyReadOnlyReason {
	NotAssignedStudyEmployee = "NOT_ASSIGNED_STUDY_EMPLOYEE",
	StageNotEditable = "STAGE_NOT_EDITABLE",
}
